import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from '../../../utils/api';

export interface AdminScholarshipConfig {
  id: number;
  institutionShortName: string;
  isEnabled: boolean;
  eligibilityTrigger: number;
  eligibilityTriggerLabel: string;
  templateFileName: string;
  templateOriginalName: string;
  allowedFileExtensions: string;
  notificationRoles: string;
  acceptanceTemplateFileName: string;
  acceptanceTemplateOriginalName: string;
  acceptanceAllowedFileExtensions: string;
  createdAt: string;
  updatedAt: string;
}

interface AdminScholarshipConfigResponse {
  statusCode: number;
  message: string;
  data: AdminScholarshipConfig;
}

export const GET_ADMIN_SCHOLARSHIP_CONFIG_QUERY_KEY = ['get-admin-scholarship-config'];

export const useGetAdminScholarshipConfigQuery = () => {
  const fetchAdminScholarshipConfig = async (): Promise<AdminScholarshipConfigResponse> => {
    return (await api.get('/admin/scholarship/config'))?.data;
  };

  const { data, isLoading, isError, error, refetch } = useQuery<
    AdminScholarshipConfigResponse,
    AxiosError<ApiErrorResponse>
  >({
    queryKey: GET_ADMIN_SCHOLARSHIP_CONFIG_QUERY_KEY,
    queryFn: fetchAdminScholarshipConfig,
  });

  const errorMessage =
    error?.response?.data?.message || error?.message || 'Failed to fetch scholarship configuration';

  return {
    data,
    scholarshipConfigData: data?.data,
    adminScholarshipConfigData: data?.data,
    isLoading,
    isScholarshipConfigLoading: isLoading,
    isAdminScholarshipConfigLoading: isLoading,
    isError,
    isScholarshipConfigError: isError,
    isAdminScholarshipConfigError: isError,
    errorMessage,
    scholarshipConfigErrorMessage: errorMessage,
    adminScholarshipConfigErrorMessage: errorMessage,
    refetch,
  };
};
